<template>
  <div class="Cart">
    <top-page-title>Количка</top-page-title>
    <section class="section bg-grey-lightest py-12">
      <div class="container xsm:px-2">
        <div class="text-xl mb-8 font-light">
          <div v-if="hasTickets">
            <cart-single-round
              v-for="(roundTickets, roundId) in tickets"
              v-if="roundTickets.length"
              :key="roundId"
              :tickets="roundTickets"
              :round-id="roundId"
              :validator="$v.tickets.$each[roundId]"
              @update="updateTickets"
            />
            <div class="flex md:justify-end border-t border-red my-4 pt-4 text-2xl">
              <underlined-heading
                class="pr-2"
                color="red"
              >
                Общо:
              </underlined-heading>
              <span>{{ getTotalPrice | money }}</span>
            </div>
            <div v-if="form.gateway !== 'bonus'" class="mt-4 mb-8">
              <underlined-heading color="red">Вземи бонус</underlined-heading>
              <div class="row items-center">
                <div class="column text-base mb-4 text-grey-dark is-expanded">
                  Въведи <strong>референтния код</strong> на друг МПС Експерт и ще получиш бонус в размер на <strong>20%</strong> от заплатената от
                  теб сума за твоята първа поръчка и <strong>10%</strong> за всяка следваща поръчка под формата на МПС Експерт Бонус Кредити.
                  <router-link
                    :to="{ name: 'terms' }"
                    class="underline"
                  >
                    Прочети повече за референтните кодове.
                  </router-link>
                </div>
                <form-field
                  class="column"
                  icon="ticket"
                >
                  <ref-code-input v-model="form.ref_code" />
                </form-field>
              </div>
            </div>
            <div class="mt-4 mb-8 flex flex-col">
              <underlined-heading color="orange">Начин на плащане</underlined-heading>
              <payment-options-picker
                v-model="form.gateway"
                class="flex flex-col"
              />
            </div>
            <div class="flex justify-between">
              <v-button
                href="#"
                color="is-orange"
                class="mr-2"
                @click.prevent="$router.go(-1)"
              >
                Назад
              </v-button>
              <v-button
                :loading="isFinalizing"
                color="is-red"
                @click="continueToPayment"
              >
                Финализирай и плати
              </v-button>
            </div>
          </div>
          <div v-else>
            Вашата количка е празна!
            <a
              href="#"
              class="text-red"
              @click.prevent="$router.go(-1)"
            >
              Назад
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TicketsTable from '@/components/TicketsTable'
import { required, minValue } from 'vuelidate/lib/validators'
import UnderlinedHeading from '@/components/core/UnderlinedHeading'
import CartSingleRound from '@/components/CartSingleRound'
import PaymentOptionsPicker from '@/components/PaymentOptionsPicker'
import RefCodeInput from '@/components/RefCodeInput'

/**
 * @module Cart
 */
export default {
  name: 'Cart',
  components: { RefCodeInput, PaymentOptionsPicker, CartSingleRound, UnderlinedHeading, TicketsTable },
  data () {
    return {
      isFinalizing: false,
      form: {
        gateway: 'epay',
        ref_code: window.sessionStorage.getItem('ref_code') || ''
      }
    }
  },
  computed: {
    ...mapGetters('shop', ['tickets', 'hasTickets', 'getTotalPrice', 'numberOfTickets'])
  },
  validations: {
    form: {
      gateway: {
        required
      }
    },
    tickets: {
      $each: {
        $each: {
          mileage: { required, minValue: minValue(1) }
        }
      }
    }
  },
  methods: {
    ...mapActions('shop', ['storeTickets', 'finishCheckout']),
    ...mapActions('user', ['fetchUser']),
    updateTickets (roundId, tickets) {
      this.storeTickets({ roundId, tickets })
    },
    async continueToPayment () {
      this.$v.$touch()
      if (this.$v.$error) return
      try {
        this.isFinalizing = true

        const payload = { gateway: this.form.gateway }
        if (this.form.ref_code && this.form.gateway !== 'bonus') {
          payload.ref_code = this.form.ref_code
        }

        await this.finishCheckout(payload)
        this.fetchUser()

        this.$ma.trackEvent({ category: 'Checkout', action: 'GoToPayment', label: this.form.gateway, value: this.getTotalPrice }, ['facebook'])

        window.fbq('trackCustom', 'Checkout', {
          type: this.form.gateway,
          ticketCount: this.numberOfTickets,
          value: this.getTotalPrice // the total sum added
        })
        window.sessionStorage.removeItem('ref_code')

        this.$router.push({ name: 'finish-order', params: { gateway: this.form.gateway } })
      } catch (err) {
        this.$displayError(err)
      } finally {
        this.isFinalizing = false
      }
    }
  }
}
</script>
